import React from "react";
import { Helmet } from "react-helmet";
import ProjectsBody from "../components/projects/ProjectsBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Projects() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.negash.co/projects"
        />
        <meta
          name="description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          property="og:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          property="og:title"
          content="Completed Projects - Negash Construction Company"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1762670639/negashcc_dviqnr.jpg"
        />

        <meta
          name="twitter:title"
          content="Completed Projects - Negash Construction Company"
        />
        <meta
          name="twitter:text:title"
          content="Completed Projects - Negash Construction Company"
        />
        <meta
          name="twitter:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1762670639/negashcc_dviqnr.jpg"
        />
        <title>Completed Projects - Negash Construction Company</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase white text-shadow"
        title="OUR PROJECTS PORTFOLIO"
      />
      <ProjectsBody />
    </>
  );
}
